import type { SVGProps } from 'react';
const SvgIconInbox = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M10.434 2H5.566a3 3 0 0 0-2.519 1.37L.981 6.563A3 3 0 0 0 .5 8.193V11a3 3 0 0 0 3 3h9a3 3 0 0 0 3-3V8.193a3 3 0 0 0-.481-1.63L12.953 3.37A3 3 0 0 0 10.434 2M4.307 4.185A1.5 1.5 0 0 1 5.566 3.5h4.868a1.5 1.5 0 0 1 1.26.685L13.513 7H11.25A1.75 1.75 0 0 0 9.5 8.75a.25.25 0 0 1-.25.25h-2.5a.25.25 0 0 1-.25-.25A1.75 1.75 0 0 0 4.75 7H2.485zM2 8.5V11a1.5 1.5 0 0 0 1.5 1.5h9A1.5 1.5 0 0 0 14 11V8.5h-2.75a.25.25 0 0 0-.25.25 1.75 1.75 0 0 1-1.75 1.75h-2.5A1.75 1.75 0 0 1 5 8.75a.25.25 0 0 0-.25-.25z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgIconInbox;
